import { Empty } from "antd";
import SalaryUploadCard from "../salaryUpload";
import { useTranslation } from "react-i18next";

export default function SalaryHistoryList({
  dataSource = [],
  handleSingleRcordDownload,
}) {
  const { t } = useTranslation();
  return (
    <>
      {dataSource.length === 0 ? (
        <Empty description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })} />
      ) : (
        <div>
          {dataSource.map((option, index) => (
            <SalaryUploadCard
              record={option}
              handleSingleRcordDownload={handleSingleRcordDownload}
            />
          ))}
        </div>
      )}
    </>
  );
}
